module.exports = __webpack_public_path__ + "static/association_org_member_badge-50ccf60582be4d18a5a88878c716dc8d.svg";